import INSIGHTS_CONFIG_PATH from '../../apiPaths';

const preProcessRequestData = data => {
  const {
    id,
    recordVersion,
    createdByUserId,
    lastModifiedByUserId,
    createdDateTime,
    lastModifiedDateTime,
    ...other
  } = data;
  return {
    ...other,
    name: other.name != null ? String(other.name) : other.name,
    value: other.value != null ? String(other.value) : other.value,
    description:
      other.description != null
        ? String(other.description)
        : (other.description ?? null),
  };
};

const preProcessFetchData = data => {
  return { ...data };
};

const getInsightConfigDataById = async (params, id) => {
  const getPageDataApiUrl = `${params?.getApiUrl()}${INSIGHTS_CONFIG_PATH}/${id}`;
  const response = await params?.get(getPageDataApiUrl);
  if (response?.ok) {
    return {
      data: preProcessFetchData(response?.data),
      errors: null,
    };
  }
  return {
    data: null,
    errors: response?.errors,
  };
};

export { preProcessRequestData, preProcessFetchData, getInsightConfigDataById };
